import React, { ReactNode } from 'react';

import { StyledButton } from './button.styled';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	title?: string;
	onClick?: () => void;
	icon?: ReactNode | undefined;
	rightIcon?: ReactNode | undefined;
	secondary?: boolean;
	type?: 'button' | 'submit' | 'reset';
	fullWidth?: boolean;
	disabled?: boolean;
	flat?: boolean;
	className?: string;
}

export const Button: React.FC<ButtonProps> = ({
	title,
	onClick,
	icon,
  rightIcon,
	secondary,
	type = 'button',
	fullWidth,
	disabled,
	flat,
	...props
}) => {
	return (
		<StyledButton
			$secondary={secondary}
			$fullWidth={fullWidth}
			$disabled={disabled}
			$flat={flat}
			$hasRightIcon={!!rightIcon}
			$title={!!title}>
			<button type={type} title={title} onClick={onClick} disabled={disabled} {...props}>
				<span>{icon}</span>
				{title}
				{rightIcon && <span className="right-icon">{rightIcon}</span>}
			</button>
		</StyledButton>
	);
};
